import { Box, TextField, Typography } from '@material-ui/core'
import { useState } from 'react'

export default function TooltipTextfield({ title = undefined as any, initialValue = '', onChange }: { title?: any, initialValue?: string, onChange: (value: string) => void }) {
	const [value, setValue] = useState(initialValue)

	return (

		<Box display="flex" gridGap="8px" justifyContent="space-between" alignItems="center">
			<Typography variant="subtitle2">{title}</Typography>
			<TextField
				variant="outlined"
				size="small"
				value={value}
				onChange={(event) => {
					const value = event.target.value
					setValue(value)
					onChange(value)
				}}
			/>
		</Box>
	)
}
